import {alias, createModelSchema, identifier, reference} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ItemBoostAction extends Cloneable {

    static NONE = new ItemBoostAction(0, "NONE");

    static _values = [
        this.NONE,
    new ItemBoostAction(1, "JOB COMPLETE"),
    new ItemBoostAction(2, "ITEM_DOWNGRADE")
];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, ItemBoostAction.getValue(id));
        });
    }

    static getValues() {
        return this._values;
    }

    static getValue(id) {
        let value = this._values.find(v => v.id === id) || null;
        console.assert(value, "unknown id: " + id);
        return value;
    }

    static is(value) {
        if (value instanceof ItemBoostAction) {
            return ItemBoostAction._values.some(v => v.id === value.id);
        } else {
            return false;
        }
    }

    static isNone(value) {
        return ItemBoostAction.NONE.equal(value);
    }

    constructor(id = 0, name = "NONE") {
        super();
        this._id = id;
        this._name = name;
    }

    get id() {
        return this._id;
    }

    get name() {
        return this._name;
    }

    equal(value) {
        if (value instanceof ItemBoostAction) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemBoostAction());
        } else if (target instanceof ItemBoostAction) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemBoostAction, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive())
});